<template>
    <div>
        <div v-if="straightLink != null">
            <div id="convert-result"
                 class="row col-lg-8 col-md-10 col-12 mx-auto mt-5 alert alert-primary shadow-lg convert-result"
                 role="alert">
                <div class="container">
                    <p class="convert-title">Download {{ isVideo ? 'video' : 'image' }} as:</p>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-4 col-lg-4 order-12 order-lg-1 mt-3 mx-auto result-col-thumb">
                            <img
                                class="card-img-top img-fluid rounded"
                                :src="img"
                                alt="">
                        </div>
                        <div class="col-12 col-lg-8 order-2">
                            <div class="col-12 p-0 m-0">
                                <div class="tabs-header row">
                                    <a class="video-title col-12 m-0 active-tab">
                                        <span><i class="fab fa-youtube"></i> {{ isVideo ? 'Video' : 'Image' }} </span>
                                    </a>
                                </div>
                            </div>
                            <div class="row m-0">
                                <div class="d-lg-block p-0 col-12">
                                    <div id="myTabContent" class="tab-content">
                                        <div id="nav-mp4" class="tab-pane active show">
                                            <table class="table table-dark table-striped table-sm mb-0" cellspacing="0">
                                                <tr>
                                                    <td scope="row">
                                                        <span><strong>{{ isVideo ? '.mp4' : '.jpg' }}</strong></span>
                                                    </td>
                                                    <td class="align-middle">
                                                        <button
                                                            class="btn"
                                                            @click="download(url)">
                                                            <i class="fas fa-download"></i>
                                                            Download
                                                        </button>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="straightLink === null && manyElements !== null">
            <div class="container text-white h-100 find-block mt-5 find-section ">
                <div class="find-block col-lg-8 convert-result ">
                    <div class="video " v-for="manyElement in manyElements"
                         :key="manyElement.pk">
                        <div class="video-desc ">
                            <img
                                 class="image"
                                 :src="manyElement.img"
                                 >
                            <button
                                class="btn btn-success btn-find-download btn-t24"
                                :href="manyElement.url"
                                @click.prevent="sendToForm(manyElement.url)"
                                @click="download(manyElement.url)"
                                > Download</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="error">
            <ErrorBlock :error="error" />
        </div>

        <loader-component v-if="isLoading" :is-loading="isLoading"></loader-component>
    </div>
</template>
<script>
import ErrorBlock from "./ErrorBlock";
import LoaderComponent from "./LoaderComponent";
import { IgApi } from "../api/instagram";

export default {
    components: {
        ErrorBlock,
        LoaderComponent,
    },
    data() {
        return {
            link: null,
            error: null,
            straightLink: null,
            img: null,
            url: null,
            mediaDownloaderHost: 'media.ddown.to',
            isVideo: false,
            manyElements:null,
            requestStartDate: 0,
            isLoading: false,
            abortController: new AbortController(),
        }
    },
    mounted() {
        this.$root.$on('clear-results', () => {
            this.straightLink = null;
            this.img = null;
            this.error = null;
            this.url = null;
            this.manyElements = null;
        });
        this.$root.$on('straight-submit', (link) => {
            this.requestStraightLink(link)
            this.link = link;
        })
    },
    methods: {
        handleError(result) {
            this.$root.$emit('show-error', result, this.link);
            this.$root.$emit('send-error-time', this.requestStartDate, this.link);
            this.error = true;
        },
        startLoading() {
            this.isLoading = true
        },
        endLoading() {
            this.isLoading = false
        },
        requestStraightLink(link) {
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = new AbortController();
            }
            this.requestStartDate = Date.now();
            const statusState = {status: false};
            if (statusState.status) return;
            this.startLoading();
            IgApi.getStory({
                trimmedQuery: link,
                signal: this.abortController.signal,
                subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody,
            }).then((success) => {
                if(success.data.result.length > 1){
                    this.$root.$emit('show-results', success.data.result, this.link, 'mp4');

                    return  this.manyElements = this.lotHighlights(success.data.result);
                }
                if (success.data.result && success.data.blacklist) return this.handleError(success.data, this.link);
                this.$root.$emit('show-results', success.data.result, this.link, 'mp4');
                this.straightLink = success.data.result[0]

                this.img = this.getPreviewUrl(success.data.result[0].image_versions2.candidates[0].url, success.data.result[0].image_versions2.candidates[0].url_signature)
                this.url = success.data.result[0].video_versions
                    ? this.getDownloadableUrl(success.data.result[0].video_versions[0].url, success.data.result[0].video_versions[0].url_signature)
                    : this.getDownloadableUrl(success.data.result[0].image_versions2.candidates[0].url, success.data.result[0].image_versions2.candidates[0].url_signature)
                this.isVideo = !!success.data.result[0].video_versions
            })
            .catch((error) => {
                let result = error.code == "ECONNABORTED" ? {timeout: true} : error.response && error.response.data;
                this.handleError(result, this.link);
            })
            .finally(() => {
                this.$root.$emit('result-end');
                this.endLoading()
            })
        },
        download(link) {
            this.$root.$emit('download-click', this.link, 'mp4');
            setTimeout(() => {
                document.location = link;
            }, 500);
        },
        getFilename(pathname) {
            const matches = pathname.match(/([\w\-]+\.(?:jpg|mp4))$/i);
            return matches ? matches[1] : '';
        },
        getPreviewUrl(url, signatureParams) {
            if (url.indexOf('?__sig=') !== -1 || url.indexOf('&__sig=') !== -1) {
                return url;
            }

            const {expires, signature} = signatureParams || {};

            if (signature) {
                return `https://${this.mediaDownloaderHost}/get?uri=${encodeURIComponent(url)}&__sig=${encodeURIComponent(signature)}&__expires=${expires}`;
            }

            return url;
        },
        getDownloadableUrl(link, signatureParams) {
            try {
                const url = new URL(link);

                if (url.searchParams.get('__sig')) {
                    return link;
                }

                url.searchParams.append('dl', '1');

                if (url.searchParams.get('efg')) {
                    const filename = this.getFilename(url.pathname);
                    if (filename) {
                        const {expires, signature} = signatureParams || {};
                        if (signature) {
                            return `https://${this.mediaDownloaderHost}/get?uri=${encodeURIComponent(link)}&filename=${encodeURIComponent(filename)}&__sig=${encodeURIComponent(signature)}&__expires=${expires}&referer=https%3A%2F%2Fwww.instagram.com%2F`;
                        }
                    }
                }

                return url.toString();
            } catch {
                if (link.indexOf('?__sig=') !== -1 || link.indexOf('&__sig=') !== -1) {
                    return link;
                }

                if (link.indexOf('?') === -1) {
                    return `${link}?dl=1`;
                }

                return `${link}&dl=1`;
            }
        },
        lotHighlights(arr) {
            let res = arr.map((el) => {
                const candidatesImg = el.image_versions2.candidates[0]
                el.img = this.getPreviewUrl(
                    candidatesImg.url,
                    candidatesImg.url_signature
                );
                el.url = el.video_versions
                    ? this.getDownloadableUrl(el.video_versions[0].url, el.video_versions[0].url_signature)
                    : this.getDownloadableUrl(
                        candidatesImg.url,
                        candidatesImg.url_signature
                    );
                el.isVideo = !!el.video_versions;

                return el;
            });
            return res;
        },
        sendToForm(url) {
            this.$root.$emit('search-download', url);
            localStorage.setItem("search",url);
            document.location = this.canonical;
        },
    }
}
</script>
